/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './activate_card';
import './list_cards';
import './search_cards';
import './reissue_card';
import './set_card_state';
import './set_card_state_for_merchant';
import './set_primary_payment_account';
import './update_address';
import './search_offers';
import './search_statements';
import './search_transactions';
import './create_application_flow';
import './list_application_flows';
import './retrieve_application_flow';
import './update_application_flow';
import './submit_application_flow';
import './cancel_application_flow';
import './retrieve_credit_line';
import './retrieve_credit_line_for_merchant';
import './make_credit_line_payment';
import './update_credit_line_autopay_settings';
import './skip_next_credit_line_auto_payment';
import './create_offer';
import './retrieve_offer';
import './retrieve_card_statement_document';
import './get_account_transfer_eligibility';
import './notify_account_transferred';
import './send_verification_email';
import './verify_verification_email';
import './retrieve_preliminary_cardholder_agreement_document';
import './retrieve_preliminary_california_finance_disclosure_document';
import './retrieve_california_finance_disclosure_document';
import './retrieve_preliminary_new_york_finance_disclosure_document';
import './retrieve_new_york_finance_disclosure_document';
import './retrieve_preliminary_florida_finance_disclosure_document';
import './retrieve_florida_finance_disclosure_document';
import './retrieve_preliminary_georgia_finance_disclosure_document';
import './retrieve_georgia_finance_disclosure_document';
import './retrieve_cardholder_agreement_document';
import './redeem_rewards';
import './search_rewards_activity';
import './fetch_earned_rewards';
import './expire_card_offers';
import './list_card_holders';
import './retrieve_card_holder';
import './retrieve_transaction';
import './credit_funds';
import './search_application_flows';
import './validate_address';
import './provision_apple_pay';
import './digital_wallet_send_verification';
import './digital_wallet_status_emails';
import './retrieve_document';
import './acknowledge_credit_limit_adjustment_viewed';
import './regenerate_statements';
import './update_credit_limit';
import './retrieve_overlap_eligibility';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "CorporateCardApi": {
                "methods": {
                  "ActivateCard": {
                    "requestType": "squareup.corporate_card.service.ActivateCardRequest",
                    "responseType": "squareup.corporate_card.service.ActivateCardResponse"
                  },
                  "ListCards": {
                    "requestType": "squareup.corporate_card.service.ListCardsRequest",
                    "responseType": "squareup.corporate_card.service.ListCardsResponse"
                  },
                  "SearchCards": {
                    "requestType": "squareup.corporate_card.service.SearchCardsRequest",
                    "responseType": "squareup.corporate_card.service.SearchCardsResponse"
                  },
                  "ReissueCard": {
                    "requestType": "squareup.corporate_card.service.ReissueCardRequest",
                    "responseType": "squareup.corporate_card.service.ReissueCardResponse"
                  },
                  "SetCardState": {
                    "requestType": "squareup.corporate_card.service.SetCardStateRequest",
                    "responseType": "squareup.corporate_card.service.SetCardStateResponse"
                  },
                  "SetCardStateForMerchant": {
                    "requestType": "squareup.corporate_card.service.SetCardStateForMerchantRequest",
                    "responseType": "squareup.corporate_card.service.SetCardStateForMerchantResponse"
                  },
                  "SetPrimaryPaymentAccount": {
                    "requestType": "squareup.corporate_card.service.SetPrimaryPaymentAccountRequest",
                    "responseType": "squareup.corporate_card.service.SetPrimaryPaymentAccountResponse"
                  },
                  "UpdateAddress": {
                    "requestType": "squareup.corporate_card.service.UpdateAddressRequest",
                    "responseType": "squareup.corporate_card.service.UpdateAddressResponse"
                  },
                  "SearchOffers": {
                    "requestType": "squareup.corporate_card.service.SearchOffersRequest",
                    "responseType": "squareup.corporate_card.service.SearchOffersResponse"
                  },
                  "SearchStatements": {
                    "requestType": "squareup.corporate_card.service.SearchStatementsRequest",
                    "responseType": "squareup.corporate_card.service.SearchStatementsResponse"
                  },
                  "SearchTransactions": {
                    "requestType": "squareup.corporate_card.service.SearchTransactionsRequest",
                    "responseType": "squareup.corporate_card.service.SearchTransactionsResponse"
                  },
                  "CreateApplicationFlow": {
                    "requestType": "squareup.corporate_card.service.CreateApplicationFlowRequest",
                    "responseType": "squareup.corporate_card.service.CreateApplicationFlowResponse"
                  },
                  "ListApplicationFlows": {
                    "requestType": "squareup.corporate_card.service.ListApplicationFlowsRequest",
                    "responseType": "squareup.corporate_card.service.ListApplicationFlowsResponse"
                  },
                  "RetrieveApplicationFlow": {
                    "requestType": "squareup.corporate_card.service.RetrieveApplicationFlowRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveApplicationFlowResponse"
                  },
                  "UpdateApplicationFlow": {
                    "requestType": "squareup.corporate_card.service.UpdateApplicationFlowRequest",
                    "responseType": "squareup.corporate_card.service.UpdateApplicationFlowResponse"
                  },
                  "SubmitApplicationFlow": {
                    "requestType": "squareup.corporate_card.service.SubmitApplicationFlowRequest",
                    "responseType": "squareup.corporate_card.service.SubmitApplicationFlowResponse"
                  },
                  "CancelApplicationFlow": {
                    "requestType": "squareup.corporate_card.service.CancelApplicationFlowRequest",
                    "responseType": "squareup.corporate_card.service.CancelApplicationFlowResponse"
                  },
                  "RetrieveCreditLine": {
                    "requestType": "squareup.corporate_card.service.RetrieveCreditLineRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveCreditLineResponse"
                  },
                  "RetrieveCreditLineForMerchant": {
                    "requestType": "squareup.corporate_card.service.RetrieveCreditLineForMerchantRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveCreditLineForMerchantResponse"
                  },
                  "MakeCreditLinePayment": {
                    "requestType": "squareup.corporate_card.service.MakeCreditLinePaymentRequest",
                    "responseType": "squareup.corporate_card.service.MakeCreditLinePaymentResponse"
                  },
                  "UpdateCreditLineAutopaySettings": {
                    "requestType": "squareup.corporate_card.service.UpdateCreditLineAutopaySettingsRequest",
                    "responseType": "squareup.corporate_card.service.UpdateCreditLineAutopaySettingsResponse"
                  },
                  "SkipNextCreditLineAutoPayment": {
                    "requestType": "squareup.corporate_card.service.SkipNextCreditLineAutoPaymentRequest",
                    "responseType": "squareup.corporate_card.service.SkipNextCreditLineAutoPaymentResponse"
                  },
                  "CreateOffer": {
                    "requestType": "squareup.corporate_card.service.CreateOfferRequest",
                    "responseType": "squareup.corporate_card.service.CreateOfferResponse"
                  },
                  "RetrieveOffer": {
                    "requestType": "squareup.corporate_card.service.RetrieveOfferRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveOfferResponse"
                  },
                  "RetrieveCardStatementDocument": {
                    "requestType": "squareup.corporate_card.service.RetrieveCardStatementDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveCardStatementDocumentResponse"
                  },
                  "GetAccountTransferEligibility": {
                    "requestType": "squareup.corporate_card.service.GetAccountTransferEligibilityRequest",
                    "responseType": "squareup.corporate_card.service.GetAccountTransferEligibilityResponse"
                  },
                  "NotifyAccountTransferred": {
                    "requestType": "squareup.corporate_card.service.NotifyAccountTransferredRequest",
                    "responseType": "squareup.corporate_card.service.NotifyAccountTransferredResponse"
                  },
                  "SendVerificationEmail": {
                    "requestType": "squareup.corporate_card.service.SendVerificationEmailRequest",
                    "responseType": "squareup.corporate_card.service.SendVerificationEmailResponse"
                  },
                  "VerifyVerificationEmail": {
                    "requestType": "squareup.corporate_card.service.VerifyVerificationEmailRequest",
                    "responseType": "squareup.corporate_card.service.VerifyVerificationEmailResponse"
                  },
                  "RetrievePreliminaryCardholderAgreementDocument": {
                    "requestType": "squareup.corporate_card.service.RetrievePreliminaryCardholderAgreementDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrievePreliminaryCardholderAgreementDocumentResponse"
                  },
                  "RetrievePreliminaryCaliforniaFinanceDisclosureDocument": {
                    "requestType": "squareup.corporate_card.service.RetrievePreliminaryCaliforniaFinanceDisclosureDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrievePreliminaryCaliforniaFinanceDisclosureDocumentResponse"
                  },
                  "RetrieveCaliforniaFinanceDisclosureDocument": {
                    "requestType": "squareup.corporate_card.service.RetrieveCaliforniaFinanceDisclosureDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveCaliforniaFinanceDisclosureDocumentResponse"
                  },
                  "RetrievePreliminaryNewYorkFinanceDisclosureDocument": {
                    "requestType": "squareup.corporate_card.service.RetrievePreliminaryNewYorkFinanceDisclosureDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrievePreliminaryNewYorkFinanceDisclosureDocumentResponse"
                  },
                  "RetrieveNewYorkFinanceDisclosureDocument": {
                    "requestType": "squareup.corporate_card.service.RetrieveNewYorkFinanceDisclosureDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveNewYorkFinanceDisclosureDocumentResponse"
                  },
                  "RetrievePreliminaryFloridaFinanceDisclosureDocument": {
                    "requestType": "squareup.corporate_card.service.RetrievePreliminaryFloridaFinanceDisclosureDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrievePreliminaryFloridaFinanceDisclosureDocumentResponse"
                  },
                  "RetrieveFloridaFinanceDisclosureDocument": {
                    "requestType": "squareup.corporate_card.service.RetrieveFloridaFinanceDisclosureDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveFloridaFinanceDisclosureDocumentResponse"
                  },
                  "RetrievePreliminaryGeorgiaFinanceDisclosureDocument": {
                    "requestType": "squareup.corporate_card.service.RetrievePreliminaryGeorgiaFinanceDisclosureDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrievePreliminaryGeorgiaFinanceDisclosureDocumentResponse"
                  },
                  "RetrieveGeorgiaFinanceDisclosureDocument": {
                    "requestType": "squareup.corporate_card.service.RetrieveGeorgiaFinanceDisclosureDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveGeorgiaFinanceDisclosureDocumentResponse"
                  },
                  "RetrieveCardholderAgreementDocument": {
                    "requestType": "squareup.corporate_card.service.RetrieveCardholderAgreementDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveCardholderAgreementDocumentResponse"
                  },
                  "RedeemRewards": {
                    "requestType": "squareup.corporate_card.service.RedeemRewardsRequest",
                    "responseType": "squareup.corporate_card.service.RedeemRewardsResponse"
                  },
                  "SearchRewardsActivity": {
                    "requestType": "squareup.corporate_card.service.SearchRewardsActivityRequest",
                    "responseType": "squareup.corporate_card.service.SearchRewardsActivityResponse"
                  },
                  "FetchEarnedRewards": {
                    "requestType": "squareup.corporate_card.service.FetchEarnedRewardsRequest",
                    "responseType": "squareup.corporate_card.service.FetchEarnedRewardsResponse"
                  },
                  "ExpireCardOffers": {
                    "requestType": "squareup.corporate_card.service.ExpireCardOffersRequest",
                    "responseType": "squareup.corporate_card.service.ExpireCardOffersResponse"
                  },
                  "ListCardHolders": {
                    "requestType": "squareup.corporate_card.service.ListCardHoldersRequest",
                    "responseType": "squareup.corporate_card.service.ListCardHoldersResponse"
                  },
                  "RetrieveCardHolder": {
                    "requestType": "squareup.corporate_card.service.RetrieveCardHolderRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveCardHolderResponse"
                  },
                  "RetrieveTransaction": {
                    "requestType": "squareup.corporate_card.service.RetrieveTransactionRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveTransactionResponse"
                  },
                  "CreditFunds": {
                    "requestType": "squareup.corporate_card.service.CreditFundsRequest",
                    "responseType": "squareup.corporate_card.service.CreditFundsResponse"
                  },
                  "SearchApplicationFlows": {
                    "requestType": "squareup.corporate_card.service.SearchApplicationFlowsRequest",
                    "responseType": "squareup.corporate_card.service.SearchApplicationFlowsResponse"
                  },
                  "ValidateAddress": {
                    "requestType": "squareup.corporate_card.service.ValidateAddressRequest",
                    "responseType": "squareup.corporate_card.service.ValidateAddressResponse"
                  },
                  "ProvisionApplePay": {
                    "requestType": "squareup.corporate_card.service.ProvisionApplePayRequest",
                    "responseType": "squareup.corporate_card.service.ProvisionApplePayResponse"
                  },
                  "DigitalWalletSendVerification": {
                    "requestType": "squareup.corporate_card.service.DigitalWalletSendVerificationRequest",
                    "responseType": "squareup.corporate_card.service.DigitalWalletSendVerificationResponse"
                  },
                  "DigitalWalletSendSuccessfulProvisionEmail": {
                    "requestType": "squareup.corporate_card.service.DigitalWalletSendSuccessfulProvisionEmailRequest",
                    "responseType": "squareup.corporate_card.service.DigitalWalletSendSuccessfulProvisionEmailResponse"
                  },
                  "RetrieveDocument": {
                    "requestType": "squareup.corporate_card.service.RetrieveDocumentRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveDocumentResponse"
                  },
                  "AcknowledgeCreditLimitAdjustmentViewed": {
                    "requestType": "squareup.corporate_card.service.AcknowledgeCreditLimitAdjustmentViewedRequest",
                    "responseType": "squareup.corporate_card.service.AcknowledgeCreditLimitAdjustmentViewedResponse"
                  },
                  "RegenerateStatements": {
                    "requestType": "squareup.corporate_card.service.RegenerateStatementsRequest",
                    "responseType": "squareup.corporate_card.service.RegenerateStatementsResponse"
                  },
                  "UpdateCreditLimit": {
                    "requestType": "squareup.corporate_card.service.UpdateCreditLimitRequest",
                    "responseType": "squareup.corporate_card.service.UpdateCreditLimitResponse"
                  },
                  "RetrieveOverlapEligibility": {
                    "requestType": "squareup.corporate_card.service.RetrieveOverlapEligibilityRequest",
                    "responseType": "squareup.corporate_card.service.RetrieveOverlapEligibilityResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CorporateCardApi) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CorporateCardApi @ squareup/corporate_card/service/corporate_card_service.proto at 68:1
 */
export const CorporateCardApi = $root.lookupService('squareup.corporate_card.service.CorporateCardApi');